import { render, staticRenderFns } from "./GestaoVaga.vue?vue&type=template&id=237b5a8e"
import script from "./GestaoVaga.vue?vue&type=script&lang=js"
export * from "./GestaoVaga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports